import { useTranslation } from "react-i18next"

import classNames from "classnames"

import * as Scrivito from "scrivito"
import { Icon } from "shared/ui/icon/Icon"

import {
  BenefitIconWidgetType,
  isBenefitsWidgetIcon
} from "../BenefitIconWidget/BenefitIconWidgetClass"
import { benefitsWidgetIconColor } from "../utils/iconColorBenefitsWidget"
import { BenefitsWidget } from "./BenefitsWidgetClass"
import "./styles/_benefits-widget.scss"

Scrivito.provideComponent(BenefitsWidget, ({ widget }) => {
  const { t } = useTranslation()
  return (
    <div className="benefits-widget">
      <div className="benefits-widget__headline">
        <Scrivito.ContentTag
          className="benefits-widget__title"
          content={widget}
          attribute="title"
        />

        <Scrivito.ContentTag
          className="benefits-widget__subtitle"
          content={widget}
          attribute="subtitle"
        />
      </div>

      <div className="benefits-widget__body">
        <table className="benefits-widget-table">
          <caption className="visually-hidden">
            {t(`BenefitsWidget.Caption`)}
          </caption>
          <thead>
            <tr className="benefits-widget-table__row header-row">
              {widget.get("columnHeaders")?.map((header, index) => (
                <th
                  scope="col"
                  className={classNames(
                    "benefits-widget-table__cell header-cell"
                  )}
                  key={header.id()}
                >
                  <Scrivito.ContentTag
                    className={classNames(
                      "benefits-widget-table__cell-content",
                      { center: index !== 0 }
                    )}
                    content={header}
                    attribute="text"
                  />
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {widget.get("items")?.map(item => {
              const iconWidgets = item.get("icons") as BenefitIconWidgetType[]
              return (
                <tr key={item.id()} className="benefits-widget-table__row">
                  <th scope="row" className="benefits-widget-table__cell">
                    <Scrivito.ContentTag
                      content={item}
                      attribute="featureLabel"
                    />
                  </th>

                  {iconWidgets?.map(iconWidget => {
                    const icon = iconWidget.get("icon")

                    return (
                      <td
                        key={iconWidget.id()}
                        className="benefits-widget-table__cell"
                      >
                        {isBenefitsWidgetIcon(icon) ? (
                          <div className="benefits-widget-table__cell-content center">
                            <Icon
                              className={benefitsWidgetIconColor(icon)}
                              name={icon}
                              aria-hidden
                            />
                            <div className="visually-hidden">
                              {t(`BenefitsWidget.Status.${icon}`)}
                            </div>
                          </div>
                        ) : null}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
})
